import React from "react";
import _ from "lodash";
// Material ui components
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// Material ui icons
import AddBoxIcon from "@material-ui/icons/AddBox";
// Styles
import { withStyles } from "@material-ui/core/styles";
// Material ui icons
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
// Actions
import { pushMessage } from "../../redux/actions/commonActions";
// Utils
import { serializeCustomSlotTypeValue } from "../../common/utils";

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  chipRoot: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap"
  },
  chip: {
    margin: theme.spacing(1)
  },
  addSlotField: {
    margin: theme.spacing(1)
  }
});

class CustomSlotSynonyms extends React.Component {
  state = { expanded: true, newSynonymValue: "" };

  handleExpandSynonymsList = () => {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  };

  handleDeleteSynonymClick = (value, synonyms, selectedSlotCustomId, selectedSlotTypeIdx, synonymToDelete) => {
    this.props.pushMessage({
      type: "info",
      message: "Updating custom slot type"
    });

    const { listCustomSlotTypesResponse } = this.props;

    if (!listCustomSlotTypesResponse || !listCustomSlotTypesResponse.custom_slots) {
      return this.props.pushMessage({
        type: "error",
        message: "Could not load list of custom slot types"
      });
    }

    const selectedSlotTypeRaw = _.cloneDeep(listCustomSlotTypesResponse.custom_slots[selectedSlotTypeIdx]); // as found in DB

    const oldValueSerialized = serializeCustomSlotTypeValue(value, synonyms, selectedSlotCustomId);
    const slotTypeValues = selectedSlotTypeRaw.slotValue;
    const oldValueIdx = slotTypeValues.indexOf(oldValueSerialized);
    const synonymToDeleteIdx = synonyms.indexOf(synonymToDelete);

    if (synonymToDeleteIdx === -1) {
      return this.props.pushMessage({
        type: "error",
        message: "There was an error in processing synonyms"
      });
    }

    const newSynonyms = _.clone(synonyms);
    newSynonyms.splice(synonymToDeleteIdx, 1);

    slotTypeValues[oldValueIdx] = serializeCustomSlotTypeValue(value, newSynonyms, selectedSlotCustomId);

    const serializedCustomSlotType = `custom_slot_type=${encodeURIComponent(
      selectedSlotTypeRaw.slotName
    )}&custom_slot_id=${encodeURIComponent(selectedSlotTypeRaw.ID)}&custom_slot_values=${encodeURIComponent(
      slotTypeValues.join("\r\n")
    )}`;

    this.props.updateCustomSlotType(serializedCustomSlotType);
  };

  validateNewSynonym = newSynonym => {
    const result = { valid: true, message: "Synonym valid" };
    const { listCustomSlotTypesResponse } = this.props;

    // Check if there are no existing custom slot types
    if (!listCustomSlotTypesResponse || !listCustomSlotTypesResponse.custom_slots) {
      result.valid = false;
      result.message = "Could not load existing custom slot types";
      return result;
    }

    const parsedCustomSlotTypeValues = this.props.parseDbSlotValues(
      this.props.listCustomSlotTypesResponse.custom_slots[this.props.selectedSlotTypeIdx]
    );
    const existingSynonyms = [];

    // Construct list of existing synonyms in all values in all custom slot types
    for (const customSlotTypeValue of parsedCustomSlotTypeValues) {
      // Check if synonyms exist
      if (
        customSlotTypeValue.synonyms &&
        customSlotTypeValue.synonyms.length > 0 &&
        customSlotTypeValue.synonyms[0] !== ""
      ) {
        existingSynonyms.push(...customSlotTypeValue.synonyms);
      }
    }

    // Check for duplicate synonym
    if (existingSynonyms.indexOf(newSynonym) !== -1) {
      result.valid = false;
      result.message = "Synonym already exists";
      return result;
    }

    return result;
  };

  handleAddSynonymClick = (value, synonyms, selectedSlotCustomId, selectedSlotTypeIdx) => {
    const newSynonym = this.state.newSynonymValue.trim();
    const validationResult = this.validateNewSynonym(newSynonym);

    if (!validationResult.valid) {
      return this.props.pushMessage({
        type: "error",
        message: validationResult.message
      });
    }

    this.props.pushMessage({
      type: "info",
      message: "Updating custom slot type"
    });

    const { listCustomSlotTypesResponse } = this.props;

    if (!listCustomSlotTypesResponse || !listCustomSlotTypesResponse.custom_slots) {
      return this.props.pushMessage({
        type: "error",
        message: "Could not load list of custom slot types"
      });
    }

    const selectedSlotTypeRaw = _.cloneDeep(listCustomSlotTypesResponse.custom_slots[selectedSlotTypeIdx]); // as found in DB

    const oldValueSerialized = serializeCustomSlotTypeValue(value, synonyms, selectedSlotCustomId);
    const slotTypeValues = selectedSlotTypeRaw.slotValue;
    const oldValueIdx = slotTypeValues.indexOf(oldValueSerialized);

    if (oldValueIdx === -1) {
      return this.props.pushMessage({
        type: "error",
        message: "There was an error in processing synonyms"
      });
    }

    let newSynonyms = [];

    if (synonyms && synonyms.length > 0 && synonyms[0] !== "") {
      newSynonyms = synonyms;
    }

    newSynonyms.push(newSynonym);

    slotTypeValues[oldValueIdx] = serializeCustomSlotTypeValue(value, newSynonyms, selectedSlotCustomId);

    const serializedCustomSlotType = `custom_slot_type=${encodeURIComponent(
      selectedSlotTypeRaw.slotName
    )}&custom_slot_id=${encodeURIComponent(selectedSlotTypeRaw.ID)}&custom_slot_values=${encodeURIComponent(
      slotTypeValues.join("\r\n")
    )}`;

    this.setState({ newSynonymValue: "" }); // reset value in text field for new synonyms

    this.props.updateCustomSlotType(serializedCustomSlotType);
  };

  handleNewSynonymTextFieldChange = event => {
    const newSynonymValue = event.currentTarget.value;
    this.setState({ newSynonymValue });
  };

  render() {
    const { expanded } = this.state;
    const { classes, synonyms, selectedValue, selectedSlotCustomId, selectedSlotTypeIdx } = this.props;

    return (
      <React.Fragment>
        <ExpansionPanel expanded={expanded} onChange={this.handleExpandSynonymsList}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Synonyms</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.chipRoot}>
            <TextField
              className={classes.addSlotField}
              placeholder="Add Synonyms"
              disabled={selectedValue === ""}
              onChange={this.handleNewSynonymTextFieldChange}
              value={this.state.newSynonymValue}
            />
            <IconButton
              onClick={() => {
                this.handleAddSynonymClick(selectedValue, synonyms, selectedSlotCustomId, selectedSlotTypeIdx);
              }}
            >
              <AddBoxIcon />
            </IconButton>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails className={classes.chipRoot}>
            {synonyms[0] !== ""
              ? synonyms.map((synonym, index) => (
                  <Chip
                    key={index}
                    variant="outlined"
                    size="small"
                    label={synonym}
                    onDelete={() =>
                      this.handleDeleteSynonymClick(
                        selectedValue,
                        synonyms,
                        selectedSlotCustomId,
                        selectedSlotTypeIdx,
                        synonym
                      )
                    }
                    className={classes.chip}
                    color="primary"
                  />
                ))
              : "No results for " + selectedValue}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </React.Fragment>
    );
  }
}

const CustomSlotSynonymsStyled = withStyles(styles)(CustomSlotSynonyms);

const mapStateToProps = state => {
  return {
    listCustomSlotTypesResponse: state.customSlots.listCustomSlotTypesResponse
  };
};

export default connect(
  mapStateToProps,
  { pushMessage }
)(CustomSlotSynonymsStyled);
